import { useTranslation } from 'react-i18next';
import { Navigate, useParams } from 'react-router-dom';

import { AnimatedRoutedDrawer } from 'src/Components/Drawers/AnimatedRoutedDrawer';
import { ContactEditionFormWrapper } from 'src/Components/Forms/Contact/ContactEditionFormWrapper';

type ContactParams = {
  contactId: string;
};

const EditContactDrawer = () => {
  const { t } = useTranslation();
  const { contactId } = useParams<ContactParams>();

  if (!contactId) {
    return <Navigate to="/" replace />;
  }

  return (
    <AnimatedRoutedDrawer title={t('editContactForm.editContact', 'Modifier le contact')}>
      {({ onClose }) => (
        <ContactEditionFormWrapper onCreate={onClose} onCancel={onClose} contactId={contactId} />
      )}
    </AnimatedRoutedDrawer>
  );
};

export default EditContactDrawer;
